import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {
    username: '',
    firstName: '',
    lastName: '',
    token: '',
    isSuperAdmin: false, 
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userInfo = { ...state.userInfo, ...action.payload };
    },
    clearUser: (state) => {
      state.userInfo = initialState.userInfo;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;